import cocktailImage from 'assets/images/img-two-for-one-cocktail.png';

const CocktailOffer = () => (
  <svg width="132" height="129" viewBox="0 0 132 129" fill="none">
    <path
      d="M9.84008 91.4769C-0.874178 74.0629 -2.94696 50.9949 6.39526 31.9761C8.91736 26.841 12.7874 22.5002 16.7485 18.3707C21.5092 13.404 26.5587 8.57648 32.5898 5.26805C46.2942 -2.25279 69.4666 -0.361881 84.1472 2.61757C157.227 17.4587 141.982 145.54 64.5882 127.209C51.0202 123.994 38.7306 116.861 27.0294 109.279C19.9927 104.716 14.1996 98.5645 9.84008 91.4769Z"
      fill="url(#pattern0_1597_3876)"
    />
    <defs>
      <pattern id="pattern0_1597_3876" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_1597_3876" transform="matrix(0.0005 0 0 0.0005081 0 -0.262149)" />
      </pattern>
      <image id="image0_1597_3876" width="2000" height="3000" xlinkHref={cocktailImage} />
    </defs>
  </svg>
);

export default CocktailOffer;
